import Apply from "../Common/Apply"

const ImportApply = props => {
    return <Apply service_id="3"/>
}

export default ImportApply